"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateImpliedRAndT = void 0;
const calculationsCore_1 = require("../calculationsCore");
const calculateImpliedRAndT = (tickers, calculationTimestamp, currentTimestamp) => {
    const res = {};
    Object.keys(tickers).forEach((current) => {
        const ticker = tickers[current];
        const expiryTime = (0, calculationsCore_1.getExpiryTimestampFromInstrumentString)(tickers[current].instrument);
        const r = (0, calculationsCore_1.calculateImpliedInterestRate)(currentTimestamp, expiryTime, ticker.indexPrice, ticker.underlyingPrice);
        const t = (0, calculationsCore_1.getTimeInYearsBetweenDates)(calculationTimestamp, expiryTime);
        const T = t <= 0 ? 0.0000001 : t;
        res[current] = { r, T };
    });
    return res;
};
exports.calculateImpliedRAndT = calculateImpliedRAndT;
